// Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

// TODO:
// 1) All routes should work IE "New Arrival" needs to map to a map to feed of new products"
// 2) Suggest making collection map to a feed of all products in category, current deployed site can be confusing with this

function Header() {
  // Collection dropdown items
  const collectionItems = [
    { name: 'SUNNY HOLIDAY', path: '/Collection/SunnyHoliday' },
    { name: 'PARIS STREETS', path: '#paris-streets' },
    { name: 'ROCK STAR', path: '#rock-star' }
  ];

  const onlineStoreItems = [
    'LIMITED EDITION',
    'NEW ARRIVAL',
    'JEWELRY',
    'APPAREL',
    'I HAVE A PLANT',
    'MERCHANDISE',
    'PO YU LIN',
    'PARROTMAN',
    'CHARITY BAZAAR',
    'VIEW ALL'
  ];

  // Search functionality
  const [searchQuery, setSearchQuery] = useState('');
  // const contactLinkRef = useRef(null);

  const handleSearch = (e) => {
    e.preventDefault();
    // Implement search functionality
    console.log('Searching for:', searchQuery);
    // In a real implementation, you would redirect to search results page or filter products
  };

  const navigateToFavorites = () => {
    // Implement navigation to favorites page
    console.log('Navigate to favorites');
  };

  const navigateToCart = () => {
    // Implement navigation to cart page
    console.log('Navigate to cart');
  };

  const navigateToLogin = () => {
    // Implement navigation to login page
    console.log('Navigate to login');
  };

  return (
    <header className="header">
      <div className="brand">
        <Link to="/">
          <img src="../index/logo.png" className="logo-img" alt="CODY SANDERSON" />
        </Link>
      </div>

      <div className="header-bottom">
        <nav className="main-nav">
          <div className="nav-item-container">
            <a href="#collection" className="nav-item">
              COLLECTION
            </a>
            <div className="dropdown-menu">
              <div className="dropdown-header">COLLECTION</div>
              {/* 
              These images on production copy are heavy, we should have a loader if we expect to support that UI...
              We should rethink the UI of the nested routes in here, currently just images is fine but maybe we should more closely mirror a chrome hearts type UI??
              */}
              {collectionItems.map((item, index) => (
                <Link to={item.path} key={index} className="dropdown-item">
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="nav-item-container">
            <a href="#online-store" className="nav-item">
              ONLINE STORE
            </a>
            <div className="dropdown-menu">
              <div className="dropdown-header">CATEGORIES</div>
              {onlineStoreItems.map((item, index) => {
                const path = `/store/${item.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`;
                return (
                  <Link to={path} key={index} className="dropdown-item">
                    {item}
                  </Link>
                );
              })}
            </div>
          </div>

          <Link to="/designer" className="nav-item">DESIGNER</Link>
          {/* <Link to="/news" className="nav-item">NEWS</Link> */}
          {/* 
            Curretly this doesn't link anywhere on the deloyed site either, should we just remove the route entirely?
          */}
          {/* 
          <div className="nav-item-container">
            
            TODO: Do we want this as a popup or a seperate page? Personally I think should lead to a seperate page, 
            and maybe we hide this in footer. It is uncommon for designer brands to promote contact so easily.
            Note: We can likely use an NPM like emailjs to fulfill static contact needs, lets get more info on expected volume
=
            <a href="#contact" className="nav-item" ref={contactLinkRef}>
              CONTACT
            </a>
            <div className="contact-dropdown-menu">
              <input type="text" placeholder="YOUR NAME" className="contact-input" />
              <input type="email" placeholder="YOUR EMAIL" className="contact-input" />
              <textarea placeholder="YOUR MESSAGE" className="contact-textarea"></textarea>
              <button className="submit-button">SUBMIT</button>
            </div>
          </div> 
          */}
        </nav>

        {/* Search form on the right side of the navigation */}
        <div className="search-container">
          <form className="search-form" onSubmit={handleSearch}>
            <input
              type="text"
              placeholder="Search products..."
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit" className="search-button">
              <img src="../index/search.png" alt="Search" className="search-icon" />
            </button>
          </form>
        </div>
      </div>

      {/* Utility buttons at top right */}
      <div className="utility-buttons">
        <button className="utility-btn" onClick={navigateToFavorites}>
          <img src="../index/star.png" alt="Favorites" className="utility-icon" />
          <span className="badge">0</span>
        </button>
        <button className="utility-btn" onClick={navigateToCart}>
          <img src="../index/shopping-bag.png" alt="Cart" className="utility-icon" />
          <span className="badge">0</span>
        </button>
        <button className="utility-btn" onClick={navigateToLogin}>
          <img src="../index/login.png" alt="Login" className="utility-icon" />
        </button>
      </div>
    </header>
  );
}

export default Header;